import { Swiper } from 'swiper';
import { Pagination, A11y } from 'swiper/modules';

export class NADIngredients {
  private element: HTMLElement;
  private swiper: Swiper | null = null;
  private observer: IntersectionObserver | null = null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.init();
  }

  private init(): void {
    this.setupSwiper();
    this.setupAnimation();
  }

  private setupSwiper(): void {
    const swiperElement = this.element.querySelector('.nad-ingredients__swiper') as HTMLElement;
    if (!swiperElement) return;

    this.swiper = new Swiper(swiperElement, {
      modules: [Pagination, A11y],
      slidesPerView: 1,
      spaceBetween: 12,
      grabCursor: true,

      // pagination: {
      //   el: this.element.querySelector('.nad-ingredients__pagination') as HTMLElement,
      //   clickable: true,
      // },

      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous ingredient',
        nextSlideMessage: 'Next ingredient',
        firstSlideMessage: 'This is the first ingredient',
        lastSlideMessage: 'This is the last ingredient',
      },

      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        480: {
          slidesPerView: 1.15,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  }

  private setupAnimation(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.nad-ingredients__card');
            cards.forEach((card, index) => {
              setTimeout(() => {
                card.classList.add('animate-in');
              }, index * 100);
            });
            this.observer?.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    this.observer.observe(this.element);
  }

  public destroy(): void {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  static initializeAll(): void {
    document.querySelectorAll<HTMLElement>('.nad-ingredients').forEach((el) => {
      if (!(el as any)._nadIngredientsInstance) {
        (el as any)._nadIngredientsInstance = new NADIngredients(el);
      }
    });
  }

  static destroyAll(): void {
    document.querySelectorAll<HTMLElement>('.nad-ingredients').forEach((el) => {
      const instance = (el as any)._nadIngredientsInstance;
      if (instance) {
        instance.destroy();
        delete (el as any)._nadIngredientsInstance;
      }
    });
  }
}
